import { EnrollmentType, PendingEnrollment } from '../../types';
import { formatStandardDate } from 'shared-utils/utils/formatDate';
import { ExtraInfoTable } from 'design-system/src/components/ExtraInfoTable/ExtraInfoTable';

export type EnrollmentInfoTableProps = {
  enrollment: PendingEnrollment;
};

export const EnrollmentInfoTable = ({ enrollment }: EnrollmentInfoTableProps) => {
  const { drug_name, patient_first_name, patient_last_name, dob, enrollment_type, template_name } = enrollment;
  return (
    <ExtraInfoTable
      data={[
        {
          label: 'Drug',
          value: drug_name,
        },
        {
          label: 'Patient',
          value: `${patient_first_name} ${patient_last_name} (${formatStandardDate(dob)})`,
        },
        {
          label: 'Enrollment type',
          value: EnrollmentType[enrollment_type],
        },
        {
          label: 'Form name',
          value: template_name,
        },
      ]}
      minFieldLabelWidth="140px"
    />
  );
};
